export const REMEMBER_ME = "REMEMBER_ME";
export const FORGET_ME = "FORGET_ME";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";


